import { render, staticRenderFns } from "./PrevSearch.vue?vue&type=template&id=1882f17b&scoped=true"
import script from "./PrevSearch.vue?vue&type=script&lang=js"
export * from "./PrevSearch.vue?vue&type=script&lang=js"
import style0 from "./PrevSearch.vue?vue&type=style&index=0&id=1882f17b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1882f17b",
  null
  
)

export default component.exports